<template>
    <detail-layout-full-width>
        <template slot="header">
            <BaseHeader :content="header" />
        </template>
        <template slot="main">
            <div class="form-wrapper">
                <el-form :model="form" :rules="rules" ref="ruleForm">
                  <div class="lg:max-w-detail lg:mr-auto">
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_aps.neodoc_uuid') }}</label>
                            <el-form-item prop="uuid">
                                <el-input :disabled="isRoleUserOrConsulta" clearable class="w-full"
                                    v-model="form.uuid" />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_aps.neodoc_token') }}</label>
                            <el-form-item prop="token">
                                <el-input :disabled="isRoleUserOrConsulta" clearable class="w-full"
                                    v-model="form.token" />
                            </el-form-item>
                        </div>
                    </div>
                    <div v-if="form.hash" class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_aps.aps_hash') }}</label>
                            <el-form-item prop="hash">
                                <el-input disabled clearable class="w-full"
                                    v-model="form.hash" />
                            </el-form-item>
                        </div>
                    </div>
                  </div>
                </el-form>
            </div>
        </template>
        <template slot="layout-extend">
          <base-footer>
            <template slot="actions">
              <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
              <base-button-responsive mode="primary" :text="isCompanyCreation && getModulesClient.length ? $t('app.save_and_continue') : $t('app.save')" icon="check" @click="submitForm('ruleForm')"
                :loading="isGeneralLoading" :disabled="isGeneralLoading" />
            </template>
          </base-footer>
        </template>
    </detail-layout-full-width>
</template>
<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getCompany } from '@/services/companies/getCompany'
import { getConfiguracionNeoDoc } from '@/services/configurations/getConfiguracionNeoDoc'
import { actualizarConfiguracionNEODoc } from '@/services/configurations/actualizarConfiguracionNEODoc'
import { i18n } from '@/i18n'

export default {
  components: {
    DetailLayoutFullWidth
  },
  data () {
    return {
      header: {
        title: i18n.t('companies.configuration_aps.aps_header'),
        icon: 'companies',
        breadcrumb: {},
        url: 'companies/detail'
      },
      form: {
        idCIFEmpresa: '',
        uuid: '',
        token: '',
        hash: '',
      },
      rules: {
        uuid: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('validation.uuid_uknownformat'),
            pattern: /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[1-5][0-9A-Fa-f]{3}-[89ABab][0-9A-Fa-f]{3}-[0-9A-Fa-f]{12}$/,
            trigger: 'blur'
          },
        ],
        token: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { 
            max: 100, 
            message: i18n.t('validation.length_max', { maxLength: 100 }),
            trigger: 'blur' 
          }
        ],
        hash: [
          {
            required: true,
            message: i18n.t('validation.uuid_uknownformat'),
            pattern: /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[1-5][0-9A-Fa-f]{3}-[89ABab][0-9A-Fa-f]{3}-[0-9A-Fa-f]{12}$/,
            trigger: 'blur'
          },
        ],
      },
    }
  },
  async mounted () {
    this.form.idCIFEmpresa = this.$route.params.id

    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })
    
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: '', name: cabeceraStored })
    } else {
      const company = await this.getCompanyData(this.form.idCIFEmpresa)
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }
    this.header.breadcrumb = breadcrumbs

    if (!this.isCompanyCreation) {
      var res = await getConfiguracionNeoDoc({ idCIFEmpresa: this.form.idCIFEmpresa })
      if (!res.blnError) {
        this.setConfig(res.Configuracion)
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
      }
    } else {
      this.$store.commit('app/setModulesClient', this.getModulesClient.filter(x => ![1].includes(x)))
    }
  },
  methods: {
    getCompanyData: async function (idCIFEmpresa) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: idCIFEmpresa }
        const company = await getCompany(params)
        if (!company.blnError) {
          return company.CIFEmpresa
        }
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setConfig: function (data) {
      this.form.uuid = data.UUIDRobotAsociado
      this.form.token = data.TokenLoginRobotAsociado
      this.form.hash = data.HashNEODoc
    },
    submitForm: async function (formName) {
      setTimeout(() => {
        this.$store.commit('setIsLoading', true)
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              idCIFEmpresa: this.form.idCIFEmpresa,
              UUIDRobotAsociado: this.form.uuid.trim(),
              TokenLoginRobotAsociado: this.form.token.trim(),
            }
            var response = await actualizarConfiguracionNEODoc(data)
            if (response && response.blnError === false && response.Respuesta) {
              this.form.hash = response.Respuesta
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              if (this.isCompanyCreation) {
                this.$store.dispatch('app/exitMode', 3)
                this.goBack()
              }
            } else {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            }
            this.$store.commit('setIsLoading', false)
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
            this.$store.commit('setIsLoading', false)
            return false
          }
        })
      }, 100)
    },
    goBack: function () {
      this.$router.push({ name: 'companies' })
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isCompanyCreation: function () {
      return !!this.$store.getters['app/isInMode'](3)
    },
    getModulesClient: function () {
      return this.$store.getters['app/getModulesClient']
    },
  }
}
</script>
